var _defs, _circle, _circle2, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCollaboration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 14,
    r: 12,
    stroke: "#050505"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 62,
    r: 12,
    stroke: "#050505"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 0v75M75 37H0",
    stroke: "#03BCAA",
    strokeDasharray: "2.74 2.74"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 0v27h27M27 74V48H0",
    stroke: "#050505"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59 0v16h16M17 74V58H0",
    stroke: "#050505"
  })));
}

var MemoSvgCollaboration = /*#__PURE__*/React.memo(SvgCollaboration);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzUiIGhlaWdodD0iNzUiIHZpZXdCb3g9IjAgMCA3NSA3NSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTMiIGN5PSIxNCIgcj0iMTIiIHN0cm9rZT0iIzA1MDUwNSIvPgo8Y2lyY2xlIGN4PSI2MSIgY3k9IjYyIiByPSIxMiIgc3Ryb2tlPSIjMDUwNTA1Ii8+CjxwYXRoIGQ9Ik0zNyAwVjc1IiBzdHJva2U9IiMwM0JDQUEiIHN0cm9rZS1kYXNoYXJyYXk9IjIuNzQgMi43NCIvPgo8cGF0aCBkPSJNNzUgMzdMLTIuNjgyMjFlLTA2IDM3IiBzdHJva2U9IiMwM0JDQUEiIHN0cm9rZS1kYXNoYXJyYXk9IjIuNzQgMi43NCIvPgo8cGF0aCBkPSJNNDggMFYyN0g3NSIgc3Ryb2tlPSIjMDUwNTA1Ii8+CjxwYXRoIGQ9Ik0yNyA3NEwyNyA0OEwxLjAzNzU1ZS0wNiA0OCIgc3Ryb2tlPSIjMDUwNTA1Ii8+CjxwYXRoIGQ9Ik01OSAwVjE2SDc1IiBzdHJva2U9IiMwNTA1MDUiLz4KPHBhdGggZD0iTTE3IDc0TDE3IDU4TC0zLjcwMmUtMDcgNTgiIHN0cm9rZT0iIzA1MDUwNSIvPgo8L3N2Zz4K";
export { MemoSvgCollaboration as ReactComponent };